<div class="subBlockContainer">
  <div class="subBlockContent">
    <child-header [title]="title" (closeEvent)="close()" [showDownload]="true" titleDownload="Download Excel" (downloadEvent)="exportLicenseReports()"></child-header>
    <div class="inner-subBlock-wrapper">
      <!-- <div class="page-title-wrapper">
        <div class="title blade-title">
          {{title}} 
        </div>
        <div  class="basic-icon download-icon" placement="bottom" ngbTooltip="Download Excel" (click)="exportLicenseReports()"></div>
        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
      </div> -->
      
        <div id="basic-info-wrapper">
          <div style="margin-bottom: 20px;" class="row filter-wrapper">
              <div class="col-md-3">
                <div class="searchInputGroup">
                  <div class="searchIcon">
                    <img src="../../images/new_ui/filter.png">
                  </div>
                  <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''" onblur="this.placeholder='Filter'" [(ngModel)]="searchField" (ngModelChange)="onChange()">
                </div>
              </div>
          </div>
        </div>

        <div class="inner-subBlock-wrapper" *ngIf="licenseReports.length > 0 && !hasEmptyFilterResult">
          <div class="shared-outer-wrapper table-header-allign">
            <table matSort (matSortChange)="sortData($event)">
              <thead>
                <tr class="row order-title-wrapper">
                  <th class="col" mat-sort-header="tenantName">TENANT NAME</th>
                  <th class="col" mat-sort-header="domain">DOMAIN</th>
                  <th class="col" mat-sort-header="productName">PRODUCT NAME</th>
                  <th class="col align-center" mat-sort-header="activeLicenses">ACTIVE LICENSES</th>
                  <th class="col align-center" mat-sort-header="consumedLicense">CONSUMED LICENSES</th>
                  <th class="col align-center" mat-sort-header="availableLicenses">AVAILABLE LICENSES</th>
                </tr>
              </thead>
            </table>
            <!-- <pagination-controls (pageChange)="p = $event" directionLinks="true" previousLabel="" nextLabel="" class="search-pagination"
              *ngIf="showPager"></pagination-controls> -->
          </div>
          <div class="shared-outer-wrapper child-body">
            <table matSort (matSortChange)="sortData($event)">
              <thead hidden="true">
                <tr class="row order-title-wrapper">
                  <th class="col" mat-sort-header="tenantName">TENANT NAME</th>
                  <th class="col" mat-sort-header="domain">DOMAIN</th>
                  <th class="col" mat-sort-header="productName">PRODUCT NAME</th>
                  <th class="col align-center" mat-sort-header="activeLicenses">ACTIVE LICENSES</th>
                  <th class="col align-center" mat-sort-header="consumedLicense">CONSUMED LICENSES</th>
                  <th class="col align-center" mat-sort-header="availableLicenses">AVAILABLE LICENSES</th>
                </tr>
              </thead>
              <tbody class="scrollable-table-body">
                <ng-container>
                  <ng-container *ngFor="let report of sortedData | TableFilterMultiple:['tenantName', 'domain', 'productName'] : searchField">
                    <tr class="row order-content-wrapper">
                      <td class="col-md orderNo-wrapper">{{report?.tenantName}}</td>
                      <td class="col-md">{{report?.domain}}</td>
                      <td class="col-md">{{report?.productName}}</td>
                      <td class="col-md align-center">{{report?.activeLicenses}}</td>
                      <td class="col-md align-center">{{report?.consumedLicense}}</td>
                      <td class="col-md align-center">{{report?.availableLicenses}}</td>
                    </tr>
                  </ng-container>
                </ng-container>
              </tbody>
            </table>
            <!-- <pagination-controls (pageChange)="p = $event" directionLinks="true" previousLabel="" nextLabel="" class="search-pagination"
              *ngIf="showPager"></pagination-controls> -->
          </div>
        </div>

        <ng-container *ngIf="hasEmptyFilterResult">
          <div class="noResult-wrapper">
            <div class="top-divider"></div>
            <div><img src="../images/new_ui/no-found.png"></div>
            <div>No results found</div>
            <div>Sorry, that search or filter combination has no results.<br>Please try different criteria.</div>
            <button (click)="filterReset()" class="button button-red button-large">Try again</button>
            <div class="noResult-feedback">Send feedback</div>
          </div>
          <div class="top-divider"></div>
        </ng-container>

          <div class="inner-subBlock-wrapper" *ngIf="loadContent && !licenseReports.length && !hasEmptyFilterResult">
              <div class="noData-wrapper">
                <div>
                    <img src="../../images/new_ui/no-subscription.png">
                  </div>
                <label class="noData-label">
                    YOU HAVE NO LICENSE <br/>
                    REPORTS YET
              </label>
              <br/>
              
              </div>
        </div>
      
    </div>
    <loading-screen *ngIf="!loadContent" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)"></loading-screen>
  </div>
</div>
